/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { MyContext } from "../../Context/MyProvider";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Loading from "../Loading";
import ImageLoad from "../ImageLoad";
import {
  LuStar,
  LuMapPin,
  LuChevronRight,
  LuSearch,
  LuX,
} from "react-icons/lu";
import { RiSearchLine } from "react-icons/ri";

const CategoryDetails = () => {
  const { t } = useTranslation();
  const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

  const [labList, setLabList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [page, setPage] = useState(1);
  const [totallength, setTotalLength] = useState(0);

  const [searchText, setSearchText] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const searchTimeout = useRef(null);

  const hasReachedBottom = useRef(false);
  const NoMoreDataRef = useRef(true);
  const navigate = useNavigate();

  const Data = sessionStorage.getItem("Docdetails");
  if (Data) {
    var { Categoryid, title } = JSON.parse(Data);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = String(position.coords.latitude);
        const long = String(position.coords.longitude);
        setLatitude(lat);
        setLongitude(long);
        fetchHomeData(lat, long, 1);
      },
      (error) => {
        setLatitude("21.215814");
        setLongitude("72.828308");
        fetchHomeData("21.215814", "72.828308", 1);
      },
    );
  }, [Categoryid]);

  const handleSearch = (val) => {
    setSearchText(val);
    if (searchTimeout.current) clearTimeout(searchTimeout.current);

    if (val.trim() === "") {
      setIsSearching(false);
      setSearchLoading(false);
      setPage(1);
      NoMoreDataRef.current = true;
      fetchHomeData(latitude || "21.215814", longitude || "72.828308", 1);
      return;
    }

    setSearchLoading(true);
    searchTimeout.current = setTimeout(() => {
      performLabSearch(val);
    }, 400);
  };

  const performLabSearch = (query) => {
    setIsSearching(true);
    
    const lat = latitude || "21.215814";
    const lon = longitude || "72.828308";

    axios
      .post(`${ApiBaseUrl}/customer/lab-search`, {
        user_lat: Number(lat),
        user_lon: Number(lon),
        category_id: Number(Categoryid),
        searchtext: query,
      })
      .then((res) => {
        console.log("res", res);

        const { ResponseCode, labs } = res.data;
        if (ResponseCode === 200) {
          setLabList(labs || []);
          setTotalLength(labs ? labs.length : 0);
          NoMoreDataRef.current = false;
        }
        setSearchLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setSearchLoading(false);
      });
  };

  const handleClearSearch = () => {
    setSearchText("");
    setIsSearching(false);
    setSearchLoading(false);
    setPage(1);
    NoMoreDataRef.current = true;
    fetchHomeData(latitude || "21.215814", longitude || "72.828308", 1);
  };

  const fetchHomeData = (lat, long, pageNum) => {
    axios
      .post(`${ApiBaseUrl}/customer/category_lab_list`, {
        category_id: Categoryid,
        lat: lat,
        lon: long,
        page: pageNum,
      })
      .then((res) => {
        const { ResponseCode, lab_list } = res.data;
        if (ResponseCode === 200) {
          if (lab_list.length === 0 || totallength > lab_list.length) {
            NoMoreDataRef.current = false;
          }

          if (pageNum === 1) {
            setLabList(lab_list);
            setTotalLength(lab_list.length);
          } else {
            setLabList((prev) => [...prev, ...lab_list]);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight = window.innerHeight;

      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

      if (
        isAtBottom &&
        !hasReachedBottom.current &&
        NoMoreDataRef.current &&
        !isSearching
      ) {
        hasReachedBottom.current = true;
        setPage((prevPage) => prevPage + 1);
      } else if (!isAtBottom && hasReachedBottom.current) {
        hasReachedBottom.current = false;
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isSearching]);

  useEffect(() => {
    if (page === 1 || !NoMoreDataRef.current || isSearching) return;
    fetchHomeData(latitude, longitude, page);
  }, [page]);

  const HandleNavigate = (item) => {
    navigate("/packages");
    sessionStorage.setItem(
      "Docprofile",
      JSON.stringify({
        Categoryid: Categoryid,
        Labid: item.id,
        title: title,
        path: "/category-details",
      }),
    );
  };

  useEffect(() => {
    loading
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "auto");
  }, [loading]);

  return (
    <div className="w-full width-container pb-[50px] content-wrapper px-4 md:px-6 max-w-7xl mx-auto">
      {loading ? (
        <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]" />
      ) : (
        <div className="flex flex-col">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 py-4 mb-6 border-b border-slate-100">
            <Link
              to="/"
              className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-2 hover:bg-slate-900 hover:text-white hover:border-slate-900 transition-all duration-200 shadow-sm"
            >
              <IoIosArrowBack className="w-4 h-4" />
              <span className="font-medium text-sm">{t("Go Home")}</span>
            </Link>

            <div className="flex items-center gap-2 text-sm text-slate-500">
              <Link
                to="/lab-details"
                className="hover:text-indigo-600 font-medium transition-colors"
              >
                {t("Lab Details")}
              </Link>
              <IoIosArrowForward className="w-3.5 h-3.5" />
              <span className="font-semibold text-slate-800">{title}</span>
            </div>
          </div>

          <div className="mt-4">
            <div className="mb-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div>
                <h2 className="text-2xl font-bold text-slate-800 tracking-tight">
                  {title} {t("Labs")}
                </h2>
                <p className="text-sm text-slate-500 mt-1">
                  {t(
                    "Select a certified diagnostic lab to view available tests & packages",
                  )}
                </p>
              </div>

              <div className="relative max-w-md w-full">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  {searchLoading ? (
                    <svg
                      className="animate-spin h-5 w-5 text-indigo-500"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                  ) : (
                    <LuSearch className="h-5 w-5 text-slate-400" />
                  )}
                </div>
                <input
                  type="text"
                  placeholder={t("Search labs...")}
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  className="block w-full pl-10 pr-10 py-2.5 border border-slate-200 rounded-2xl bg-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all duration-200 text-sm shadow-sm"
                />
                {searchText && (
                  <button
                    onClick={handleClearSearch}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-slate-600"
                  >
                    <LuX className="h-5 w-5" />
                  </button>
                )}
              </div>
            </div>

            {/* Verified Labs Grid matching ShopList */}
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {labList.length >= 1 ? (
                labList.map((item, index) => {
                  return (
                    <div
                      onClick={() => HandleNavigate(item)}
                      key={index}
                      className="group bg-white rounded-3xl border border-slate-150 hover:border-indigo-500/20 overflow-hidden cursor-pointer shadow-sm hover:shadow-md hover:-translate-y-1.5 transition-all duration-350 flex flex-col relative isolate"
                    >
                      <div className="relative h-48 md:h-52 overflow-hidden bg-slate-100 rounded-t-3xl isolate">

                        <ImageLoad
                          src={ImgBaseUrl + item.logo}
                          CustomeStyle="w-full h-full object-cover overflow-hidden transition-transform duration-500 group-hover:scale-105 transform-gpu"
                          alt={item.name}
                        />

                        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 via-transparent to-transparent opacity-60 group-hover:opacity-40 transition-opacity duration-300"></div>

                        <div className="absolute bottom-3 left-3 bg-white/95 backdrop-blur-md text-slate-800 text-xs font-semibold px-2.5 py-1 rounded-full flex items-center gap-1 shadow-sm">
                          <LuMapPin className="w-3.5 h-3.5 text-indigo-600" />
                          <span>{item.distance} km</span>
                        </div>
                      </div>

                      {/* Details Info Container */}
                      <div className="p-5 flex-1 flex flex-col justify-between">
                        <div>
                          <div className="flex items-start justify-between gap-2 mb-1.5">
                            <h3 className="font-bold text-slate-800 text-[16px] group-hover:text-indigo-600 transition-colors duration-200 line-clamp-1 w-full">
                              {item.name}
                            </h3>
                            <div className="flex items-center gap-1 bg-amber-50 text-amber-700 px-2 py-0.5 rounded-full shrink-0 border border-amber-100">
                              <LuStar className="w-3.5 h-3.5 fill-amber-500 text-amber-500" />
                              <span className="text-xs font-bold leading-none">
                                {item.avg_star}
                              </span>
                            </div>
                          </div>

                          <p className="text-slate-500 text-sm leading-relaxed line-clamp-2">
                            {item.address}
                          </p>
                        </div>

                        {/* Card Footer Divider Action */}
                        <div className="mt-4 pt-3 border-t border-slate-100 flex items-center justify-between text-indigo-600 font-semibold text-sm">
                          <span>{t("Select Packages")}</span>
                          <span className="w-7 h-7 bg-indigo-50 text-indigo-600 rounded-full flex items-center justify-center transition-all duration-300 group-hover:bg-indigo-600 group-hover:text-white">
                            <LuChevronRight className="w-4 h-4" />
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="col-span-full bg-slate-50 rounded-3xl p-10 flex flex-col items-center justify-center text-center border border-dashed border-slate-200/80">
                  <div className="w-16 h-16 bg-slate-200/50 rounded-full flex items-center justify-center text-slate-400 mb-4">
                    <LuMapPin className="w-8 h-8" />
                  </div>
                  <h3 className="font-bold text-slate-800 text-lg">
                    {t("No Labs Available")}
                  </h3>
                  <p className="text-slate-500 text-sm max-w-xs mt-1">
                    {t(
                      "We couldn't find any diagnostic labs near your location.",
                    )}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryDetails;
/* jshint ignore:end */
